module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img28.6377d402.jpg";